export default "__VITE_ASSET__X$9KNTFl__"